import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

/**
 * Опции для операций с файлами
 */
interface FileOperationOptions {
  signal?: AbortSignal;
  onProgress?: (progress: { percentage: number; loaded?: number; total?: number }) => void;
}

/**
 * DAO для работы с файлами
 * Только доступ к данным через RPC запросы, без гидрации и бизнес-логики
 * Никаких batch операций - только одиночные безопасные операции
 * AbortError обрабатывается на уровне RPC, здесь только передача данных
 */
class FilesDAO {

  /**
   * Получить список файлов
   * @param {EntityPointer[]} parentEntities - Родительские сущности
   */
  static async getList(parentEntities): Promise<RpcResponse> {
    return await RpcService.makeRequest('files.getList', {
      parentEntity: parentEntities
    });
  }

  /**
   * Загрузить файл
   * @param {Object} fileData - Данные файла
   * @param {FileOperationOptions} options - Опции запроса
   */
  static async upload(fileData: object, options: FileOperationOptions = {}): Promise<RpcResponse> {
    return await RpcService.makeRequest(
        'files.add',
        fileData,
        {}, // pagination
        {}, // sort
        false, // showLoader
        null, // onSuccess
        null, // onError
        false, // compatibilityMode
        {
          signal: options.signal,
          onProgress: options.onProgress
        }
    );
  }

  /**
   * Скачать файл
   * @param {string} uid - Уникальный идентификатор файла
   * @param {FileOperationOptions} options - Опции запроса
   */
  static async download(uid: string, options: FileOperationOptions = {}): Promise<RpcResponse> {
    return await RpcService.makeRequest(
        'files.download',
        { uid },
        {}, // pagination
        {}, // sort,
        false, // showLoader
        null, // onSuccess
        null, // onError
        false, // compatibilityMode
        {
          signal: options.signal,
          onProgress: options.onProgress
        }
    );
  }

  /**
   * Удалить файл
   * @param {string} uid - Уникальный идентификатор файла
   */
  static async delete(uid): Promise<RpcResponse> {
    return await RpcService.makeRequest('files.delete', { uid });
  }

  /**
   * Получить информацию о файле
   * @param {string} uid - Уникальный идентификатор файла
   */
  static async getInfo(uid): Promise<RpcResponse> {
    return await RpcService.makeRequest('files.getInfo', { uid });
  }
}

export default FilesDAO;
